var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "reward",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "reward-main main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "reward__title"
  }, [_vm._v(_vm._s(_vm.$lang("Rewards")))]), _c('div', {
    staticClass: "reward__sub"
  }, [_vm._v("Collect MARSP that you can spend on amazing "), _vm.isMobile ? _c('br') : _vm._e(), _vm._v("prizes and airdrops")]), _c('div', {
    staticClass: "reward-marsp"
  }, [_vm._v(" MARSP CONTRACT："), _c('span', {
    staticClass: "hover",
    on: {
      "click": _vm.onCopy
    }
  }, [!_vm.isMobile ? [_vm._v(_vm._s(_vm.marspAddr))] : [_vm._v(_vm._s(_vm.fmt_addr(_vm.marspAddr, 12)))], _c('svg-icon', {
    attrs: {
      "name": "copy"
    }
  })], 2), _c('span', {
    staticClass: "link hover",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onSkip.apply(null, arguments);
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-share"
    }
  })], 1)]), _c('div', {
    staticClass: "reward-total"
  }, [_c('div', {
    staticClass: "reward-pool"
  }, [_c('div', {
    staticClass: "reward-pool-q wow zoomIn",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_c('i', {
    style: {
      zIndex: 1,
      background: 'url(' + require('@images/ui/reward/mining-q-1.png') + ') center/auto 100% no-repeat'
    }
  }), _c('span', {
    staticClass: "left",
    style: {
      zIndex: 2,
      background: 'url(' + require('@images/ui/reward/mining-q-2.png') + ') center/auto 100% no-repeat'
    }
  }), _c('span', {
    staticClass: "right",
    style: {
      zIndex: 3,
      background: 'url(' + require('@images/ui/reward/mining-q-3.png') + ') center/auto 100% no-repeat'
    }
  }), _c('span', {
    staticClass: "left",
    style: {
      zIndex: 4,
      background: 'url(' + require('@images/ui/reward/mining-q-4.png') + ') center/auto 100% no-repeat'
    }
  }), _c('span', {
    staticClass: "right",
    style: {
      zIndex: 5,
      background: 'url(' + require('@images/ui/reward/mining-q-5.png') + ') center/auto 100% no-repeat'
    }
  })]), _c('div', {
    attrs: {
      "id": "particles-js"
    }
  }), _c('div', {
    staticClass: "reward-pool-main wow zoomIn",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? _c('div', {
    staticClass: "reward-pool__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Rewards")))])]) : _vm._e(), !_vm.isWallet ? _c('div', {
    staticClass: "reward-pool__num wow zoomIn",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v("Connect Wallet")]) : _vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? _c('div', {
    staticClass: "reward-pool__num wow zoomIn",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v(" " + _vm._s(_vm.web3Data.pending !== null ? _vm.fmt_pre(_vm.fmt_floatDec(_vm.web3Data.pending), 4, true, false) : "--") + " ")]) : _vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === false ? _c('div', {
    staticClass: "reward-pool__num wow zoomIn",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v(_vm._s(_vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === false ? "Coming Soon" : "--"))]) : _vm._e(), _vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? _c('div', {
    staticClass: "reward-pool__time wow zoomIn",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v("$MARSP")]) : _vm._e()])]), !_vm.isWallet ? _c('div', {
    staticClass: "reward-btn btn",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("Connect Wallet")) + " ")]) : _vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? _c('div', {
    staticClass: "reward-btn btn",
    on: {
      "click": _vm.onClaim
    }
  }, [!_vm.isClaimLoading ? [_vm._v(" " + _vm._s(_vm.$lang("CLAIM")) + " ")] : [_c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  })]], 2) : _vm._e()]), _c('div', {
    staticClass: "reward-info"
  }, [_c('div', {
    staticClass: "reward-info-item mp"
  }, [_c('div', {
    staticClass: "reward-info__title"
  }, [_vm._v(_vm._s(_vm.$lang("My Power")))]), _c('div', {
    staticClass: "reward-info__label ma"
  }, [_vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? [_vm._v(" " + _vm._s(_vm.web3Data.myPower !== null && _vm.web3Data.myPower != 0 ? _vm.fmt_th(_vm.fmt_floatDec(_vm.web3Data.myPower) * 1000, 4, true, false) : "0") + " ")] : [_vm._v("--")]], 2)]), _c('div', {
    staticClass: "reward-info-item"
  }, [_c('div', {
    staticClass: "reward-info__title"
  }, [_vm._v(_vm._s(_vm.$lang("My Stake($MARSP)")))]), _c('div', {
    staticClass: "reward-info__label ma"
  }, [_vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? [_vm._v(" " + _vm._s(_vm.web3Data.myStake !== null && _vm.web3Data.myStake != 0 ? _vm.fmt_th(_vm.fmt_floatDec(_vm.web3Data.myStake), 4) : "0") + " ")] : [_vm._v("--")]], 2), _vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? _c('div', {
    staticClass: "reward-info-btns"
  }, [_c('div', {
    staticClass: "btn btn-unstake",
    on: {
      "click": _vm.onUnstake
    }
  }, [_vm._v(_vm._s(_vm.$lang("Unstake")))])]) : _vm._e()]), _c('div', {
    staticClass: "reward-info-item"
  }, [_c('div', {
    staticClass: "reward-info__title"
  }, [_vm._v(_vm._s(_vm.$lang("My MARSP")))]), _c('div', {
    staticClass: "reward-info__label ma"
  }, [_vm._m(0), _c('i', [_vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? [_vm._v(" " + _vm._s(_vm.web3Data.myMaspBalance !== null && _vm.web3Data.myMaspBalance != 0 ? _vm.fmt_th(_vm.fmt_floatDec(_vm.web3Data.myMaspBalance), 4, true, false) : "0") + " ")] : [_vm._v("--")]], 2)]), _vm.web3Data.poolStarted !== null && _vm.web3Data.poolStarted === true ? _c('div', {
    staticClass: "reward-info-btns"
  }, [_c('div', {
    staticClass: "btn btn-unstake",
    on: {
      "click": _vm.onStake
    }
  }, [_vm._v(_vm._s(_vm.$lang("Stake")))]), _c('div', {
    staticClass: "btn btn-stake",
    on: {
      "click": _vm.onBuy
    }
  }, [_vm._v(_vm._s(_vm.$lang("Buy")))])]) : _vm._e()])]), _c('div', {
    staticClass: "reward-pledge"
  }, [_c('div', {
    staticClass: "reward-pledge__title"
  }, [_vm._v(_vm._s(_vm.$lang("Platform")))]), _c('div', {
    staticClass: "reward-pledge-list"
  }, [_c('div', {
    staticClass: "reward-pledge-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Total Stake")))]), _vm._v(" " + _vm._s(_vm.web3Data.platformTotalStake !== null ? _vm.fmt_th(_vm.fmt_floatDec(_vm.web3Data.platformTotalStake), 4) : "--") + " $MARSP ")]), _c('div', {
    staticClass: "reward-pledge-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Total Power")))]), _vm._v(" " + _vm._s(_vm.web3Data.platformTotalPower !== null ? _vm.fmt_th(_vm.fmt_floatDec(_vm.web3Data.platformTotalPower) * 1000, 4) : "--") + " ")]), _c('div', {
    staticClass: "reward-pledge-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Apr")))]), _vm._v(" " + _vm._s(_vm.fmt_dp(_vm.web3Data.apr, 2)) + "% ")])])])]), _c('pop-stake', {
    attrs: {
      "show": _vm.popStakeShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popStakeShow = $event;
      }
    }
  }), _c('pop-un-stake', {
    attrs: {
      "show": _vm.popUnStakeShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popUnStakeShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "mLogo"
  }, [_c('img', {
    attrs: {
      "src": require("@images/ui/marspump.png"),
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };